import React from "react";
import PageHeader from "../components/common/PageHeader";
import PageMeta from "../components/common/PageMeta";
import Navbar from "../layout/Header/Navbar";
import Layout from "../layout/Layout";
import Footer from "../components/Home/Footer";
import ContactPartnerForm from "../components/contactPartner/ContactPartnerForm";

const ContactPartners = () => {
  return (
    <Layout>
      <PageMeta title="Sunlex" />
      <Navbar classOption="navbar-light" />
      <PageHeader
        title="Contact Us"
        desc="We’re here to help. Whether you have questions about our platform, need technical support, or want to explore how our solution can support your business, our team is ready to assist. Get in touch with us using the details below, and we’ll respond as soon as possible."
      />
      <ContactPartnerForm />
      <Footer />
    </Layout>
  );
};

export default ContactPartners;
